import React from 'react';
import { CircleHelp } from 'lucide-react';

interface HelpProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Help: React.FC<HelpProps> = ({ width = 20, height = 20, className, style }) => (
  <CircleHelp width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Help;
